<template>
  <footer class="m-footer">
    <div class="content mx-auto">
      <div class="link-block">
        <router-link v-for="(item, index) in linkList" class="link" :key="index" :to="item.to">{{
          item.name
        }}</router-link>
      </div>
      <p class="copyright">
        COPYRIGHT © 2002-2019 333F.COM.INC.ALL RIGHTS RESERVED.
        <a href="http://www.beian.miit.gov.cn" target="_blank">
          粤ICP备10217460号-9
        </a>
      </p>
      <p class="copyright">
        版权所有：
        <a href="http://www.333f.com/" target="_blank">广州市三川田文化科技股份有限公司</a>
      </p>
      <!-- <div class="share-link-block">
        <a class="link" href="http://www.333f.com/" target="_blank"
          >广州市三川田文化科技股份有限公司</a
        >
        <a class="link" href="https://www.xbzgj.net" target="_blank">广州小包子数据科技有限公司</a>
      </div> -->
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.m-footer {
  width: 100%;
  color: white;
  background-color: #333;
  padding: 4rem;

  .content {
    max-width: 33rem;
    .link-block {
      display: flex;
      justify-content: space-around;
      .link {
        color: white;
        font-size: 1rem;
      }
      margin-bottom: 1.8rem;
    }
    .copyright {
      font-size: 0.75rem;
      text-align: center;
    }
    .share-link-block {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .link {
        white-space: nowrap;
        text-align: center;
        flex-basis: 100%;
        font-size: 0.88rem;
        color: white;
        text-decoration: underline;
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      linkList: [
        { name: '交易中心', to: '/market' },
        { name: '认证供应商', to: '/vendor' },
        { name: '关于我们', to: '/about' },
      ],
    };
  },
};
</script>
